<template>
    <v-container>
        <p class="font-weight-black display-4">Troubleshooting</p>
        <p class="font-weight-regular title">If methods listed below cannot solve your question, please write an email to <a href="mailto:depthware+diffuse@gmail.com">App Support</a> with your specific issues.</p>

        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>Diffuse is always replaced by other app on lock screen.</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="overline">Solution</p>
                    Please check your music app to see if it has options like 'Show custom lock screen', and turn them off.
                    <br>
                    If your music app does not have such options, then please proceed to the system settings - display and check if there is a lock screen related section.
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Diffuse cannot detect my music app.</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="overline">Solution</p>
                    Please go to the settings panel of your music app and find options like 'music notification style'. Change it to system style and it should be fine.
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
    export default {
        name: "TroubleShoot"
    }
</script>

<style scoped>

</style>